"use strict";

var _regeneratorRuntime = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var analyzer_1 = require("./analyzer");

var aql_query_1 = require("./aql-query");

var collection_1 = require("./collection");

var connection_1 = require("./connection");

var cursor_1 = require("./cursor");

var error_1 = require("./error");

var graph_1 = require("./graph");

var route_1 = require("./route");

var transaction_1 = require("./transaction");

var btoa_1 = require("./util/btoa");

var multipart_1 = require("./util/multipart");

var view_1 = require("./view");

function colToString(collection) {
  if (collection_1.isArangoCollection(collection)) {
    return String(collection.name);
  } else return String(collection);
}

var DATABASE_NOT_FOUND = 1228;

var Database = /*#__PURE__*/function () {
  function Database(config) {
    _classCallCheck(this, Database);

    this._connection = new connection_1.Connection(config);
  }

  _createClass(Database, [{
    key: "version",
    //#region misc
    value: function version() {
      return this._connection.request({
        method: "GET",
        path: "/_api/version"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "route",
    value: function route(path, headers) {
      return new route_1.Route(this._connection, path, headers);
    }
  }, {
    key: "acquireHostList",
    value: function acquireHostList() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var urls;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._connection.getDatabaseName()) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Cannot acquire host list with absolute URL");

              case 2:
                _context.next = 4;
                return this._connection.request({
                  path: "/_api/cluster/endpoints"
                }, function (res) {
                  return res.body.endpoints.map(function (endpoint) {
                    return endpoint.endpoint;
                  });
                });

              case 4:
                urls = _context.sent;

                this._connection.addToHostList(urls);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      this._connection.close();
    } //#endregion
    //#region auth

  }, {
    key: "login",
    value: function login() {
      var _this = this;

      var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
      var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return this._connection.request({
        method: "POST",
        path: "/_open/auth",
        body: {
          username: username,
          password: password
        }
      }, function (res) {
        _this.useBearerAuth(res.body.jwt);

        return res.body.jwt;
      });
    }
  }, {
    key: "useBearerAuth",
    value: function useBearerAuth(token) {
      this._connection.setHeader("authorization", "Bearer ".concat(token));

      return this;
    }
  }, {
    key: "useBasicAuth",
    value: function useBasicAuth() {
      var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
      var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      this._connection.setHeader("authorization", "Basic ".concat(btoa_1.btoa("".concat(username, ":").concat(password))));

      return this;
    } //#endregion
    //#region databases

  }, {
    key: "useDatabase",
    value: function useDatabase(databaseName) {
      this._connection.setDatabaseName(databaseName);

      return this;
    }
  }, {
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/_api/database/current"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isArangoError(err) && err.errorNum === DATABASE_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "createDatabase",
    value: function createDatabase(databaseName, users) {
      return this._connection.request({
        method: "POST",
        path: "/_api/database",
        body: {
          users: users,
          name: databaseName
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listDatabases",
    value: function listDatabases() {
      return this._connection.request({
        path: "/_api/database"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "listUserDatabases",
    value: function listUserDatabases() {
      return this._connection.request({
        path: "/_api/database/user"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "dropDatabase",
    value: function dropDatabase(databaseName) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/database/".concat(databaseName)
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region collections

  }, {
    key: "collection",
    value: function collection(collectionName) {
      return new collection_1.DocumentCollection(this._connection, collectionName);
    }
  }, {
    key: "edgeCollection",
    value: function edgeCollection(collectionName) {
      return new collection_1.EdgeCollection(this._connection, collectionName);
    }
  }, {
    key: "listCollections",
    value: function listCollections() {
      var _this2 = this;

      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._connection.request({
        path: "/_api/collection",
        qs: {
          excludeSystem: excludeSystem
        }
      }, function (res) {
        return _this2._connection.arangoMajor <= 2 ? res.body.collections : res.body.result;
      });
    }
  }, {
    key: "collections",
    value: function collections() {
      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var collections;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.listCollections(excludeSystem);

              case 2:
                collections = _context2.sent;
                return _context2.abrupt("return", collections.map(function (data) {
                  return collection_1.constructCollection(_this3._connection, data);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "truncate",
    value: function truncate() {
      var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var collections;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.listCollections(excludeSystem);

              case 2:
                collections = _context3.sent;
                _context3.next = 5;
                return Promise.all(collections.map(function (data) {
                  return _this4._connection.request({
                    method: "PUT",
                    path: "/_api/collection/".concat(data.name, "/truncate")
                  }, function (res) {
                    return res.body;
                  });
                }));

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    } //#endregion
    //#region views

  }, {
    key: "arangoSearchView",
    value: function arangoSearchView(viewName) {
      return new view_1.ArangoSearchView(this._connection, viewName);
    }
  }, {
    key: "listViews",
    value: function listViews() {
      return this._connection.request({
        path: "/_api/view"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "views",
    value: function views() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var views;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.listViews();

              case 2:
                views = _context4.sent;
                return _context4.abrupt("return", views.map(function (data) {
                  return view_1.constructView(_this5._connection, data);
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    } //#endregion
    //#region analyzers

  }, {
    key: "analyzer",
    value: function analyzer(name) {
      return new analyzer_1.ArangoAnalyzer(this._connection, name);
    }
  }, {
    key: "listAnalyzers",
    value: function listAnalyzers() {
      return this._connection.request({
        path: "/_api/analyzer"
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "analyzers",
    value: function analyzers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;

        var analyzers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.listAnalyzers();

              case 2:
                analyzers = _context5.sent;
                return _context5.abrupt("return", analyzers.map(function (data) {
                  return _this6.analyzer(data.name);
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    } //#endregion
    //#region transactions

  }, {
    key: "executeTransaction",
    value: function executeTransaction(collections, action, options) {
      return this._connection.request({
        method: "POST",
        path: "/_api/transaction",
        body: Object.assign({
          collections: coerceTransactionCollections(collections),
          action: action
        }, options)
      }, function (res) {
        return res.body.result;
      });
    }
  }, {
    key: "transaction",
    value: function transaction(collectionsOrId, action, params, options) {
      if (arguments.length === 1 && typeof collectionsOrId === "string") {
        return new transaction_1.ArangoTransaction(this._connection, collectionsOrId);
      }

      if (typeof params === "number") {
        options = params;
        params = undefined;
      }

      if (typeof options === "number") {
        options = {
          lockTimeout: options
        };
      }

      return this.executeTransaction(collectionsOrId, action, Object.assign({
        params: params
      }, options));
    }
  }, {
    key: "beginTransaction",
    value: function beginTransaction(collections, options) {
      var _this7 = this;

      return this._connection.request({
        method: "POST",
        path: "/_api/transaction/begin",
        body: Object.assign({
          collections: coerceTransactionCollections(collections)
        }, options)
      }, function (res) {
        return new transaction_1.ArangoTransaction(_this7._connection, res.body.result.id);
      });
    }
  }, {
    key: "listTransactions",
    value: function listTransactions() {
      return this._connection.request({
        path: "/_api/transaction"
      }, function (res) {
        return res.body.transactions;
      });
    }
  }, {
    key: "transactions",
    value: function transactions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this8 = this;

        var transactions;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.listTransactions();

              case 2:
                transactions = _context6.sent;
                return _context6.abrupt("return", transactions.map(function (data) {
                  return _this8.transaction(data.id);
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    } //#endregion
    //#region graphs

  }, {
    key: "graph",
    value: function graph(graphName) {
      return new graph_1.Graph(this._connection, graphName);
    }
  }, {
    key: "listGraphs",
    value: function listGraphs() {
      return this._connection.request({
        path: "/_api/gharial"
      }, function (res) {
        return res.body.graphs;
      });
    }
  }, {
    key: "graphs",
    value: function graphs() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this9 = this;

        var graphs;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.listGraphs();

              case 2:
                graphs = _context7.sent;
                return _context7.abrupt("return", graphs.map(function (data) {
                  return _this9.graph(data._key);
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "query",
    value: function query(_query, bindVars, opts) {
      var _this10 = this;

      if (aql_query_1.isAqlQuery(_query)) {
        opts = bindVars;
        bindVars = _query.bindVars;
        _query = _query.query;
      } else if (aql_query_1.isAqlLiteral(_query)) {
        _query = _query.toAQL();
      }

      var _a = opts || {},
          _a$allowDirtyRead = _a.allowDirtyRead,
          allowDirtyRead = _a$allowDirtyRead === void 0 ? undefined : _a$allowDirtyRead,
          _a$timeout = _a.timeout,
          timeout = _a$timeout === void 0 ? undefined : _a$timeout,
          extra = __rest(_a, ["allowDirtyRead", "timeout"]);

      return this._connection.request({
        method: "POST",
        path: "/_api/cursor",
        body: Object.assign({}, extra, {
          query: _query,
          bindVars: bindVars
        }),
        allowDirtyRead: allowDirtyRead,
        timeout: timeout
      }, function (res) {
        return new cursor_1.ArrayCursor(_this10._connection, res.body, res.arangojsHostId, allowDirtyRead);
      });
    }
  }, {
    key: "explain",
    value: function explain(query, bindVars, opts) {
      if (aql_query_1.isAqlQuery(query)) {
        opts = bindVars;
        bindVars = query.bindVars;
        query = query.query;
      } else if (aql_query_1.isAqlLiteral(query)) {
        query = query.toAQL();
      }

      return this._connection.request({
        method: "POST",
        path: "/_api/explain",
        body: {
          options: opts,
          query: query,
          bindVars: bindVars
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "parse",
    value: function parse(query) {
      if (aql_query_1.isAqlQuery(query)) {
        query = query.query;
      } else if (aql_query_1.isAqlLiteral(query)) {
        query = query.toAQL();
      }

      return this._connection.request({
        method: "POST",
        path: "/_api/query",
        body: {
          query: query
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "queryTracking",
    value: function queryTracking() {
      return this._connection.request({
        method: "GET",
        path: "/_api/query/properties"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setQueryTracking",
    value: function setQueryTracking(opts) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/query/properties",
        body: opts
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listRunningQueries",
    value: function listRunningQueries() {
      return this._connection.request({
        method: "GET",
        path: "/_api/query/current"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listSlowQueries",
    value: function listSlowQueries() {
      return this._connection.request({
        method: "GET",
        path: "/_api/query/slow"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearSlowQueries",
    value: function clearSlowQueries() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/query/slow"
      }, function () {
        return undefined;
      });
    }
  }, {
    key: "killQuery",
    value: function killQuery(queryId) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/query/".concat(queryId)
      }, function () {
        return undefined;
      });
    } //#endregion
    //#region functions

  }, {
    key: "listFunctions",
    value: function listFunctions() {
      return this._connection.request({
        path: "/_api/aqlfunction"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createFunction",
    value: function createFunction(name, code) {
      return this._connection.request({
        method: "POST",
        path: "/_api/aqlfunction",
        body: {
          name: name,
          code: code
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "dropFunction",
    value: function dropFunction(name) {
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this._connection.request({
        method: "DELETE",
        path: "/_api/aqlfunction/".concat(name),
        body: {
          group: group
        }
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region services

  }, {
    key: "listServices",
    value: function listServices() {
      return this._connection.request({
        path: "/_api/foxx"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "installService",
    value: function installService(mount, source) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var configuration, dependencies, qs, req;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                configuration = opts.configuration, dependencies = opts.dependencies, qs = __rest(opts, ["configuration", "dependencies"]);
                _context8.next = 3;
                return multipart_1.toForm({
                  configuration: configuration,
                  dependencies: dependencies,
                  source: source
                });

              case 3:
                req = _context8.sent;
                _context8.next = 6;
                return this._connection.request(Object.assign({}, req, {
                  method: "POST",
                  path: "/_api/foxx",
                  isBinary: true,
                  qs: Object.assign({}, qs, {
                    mount: mount
                  })
                }), function (res) {
                  return res.body;
                });

              case 6:
                return _context8.abrupt("return", _context8.sent);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "upgradeService",
    value: function upgradeService(mount, source) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var configuration, dependencies, qs, req;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                configuration = opts.configuration, dependencies = opts.dependencies, qs = __rest(opts, ["configuration", "dependencies"]);
                _context9.next = 3;
                return multipart_1.toForm({
                  configuration: configuration,
                  dependencies: dependencies,
                  source: source
                });

              case 3:
                req = _context9.sent;
                _context9.next = 6;
                return this._connection.request(Object.assign({}, req, {
                  method: "PATCH",
                  path: "/_api/foxx/service",
                  isBinary: true,
                  qs: Object.assign({}, qs, {
                    mount: mount
                  })
                }), function (res) {
                  return res.body;
                });

              case 6:
                return _context9.abrupt("return", _context9.sent);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "replaceService",
    value: function replaceService(mount, source) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var configuration, dependencies, qs, req;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                configuration = opts.configuration, dependencies = opts.dependencies, qs = __rest(opts, ["configuration", "dependencies"]);
                _context10.next = 3;
                return multipart_1.toForm({
                  configuration: configuration,
                  dependencies: dependencies,
                  source: source
                });

              case 3:
                req = _context10.sent;
                _context10.next = 6;
                return this._connection.request(Object.assign({}, req, {
                  method: "PUT",
                  path: "/_api/foxx/service",
                  isBinary: true,
                  qs: Object.assign({}, qs, {
                    mount: mount
                  })
                }), function (res) {
                  return res.body;
                });

              case 6:
                return _context10.abrupt("return", _context10.sent);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "uninstallService",
    value: function uninstallService(mount) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._connection.request({
        method: "DELETE",
        path: "/_api/foxx/service",
        qs: Object.assign({}, opts, {
          mount: mount
        })
      }, function () {
        return undefined;
      });
    }
  }, {
    key: "getService",
    value: function getService(mount) {
      return this._connection.request({
        path: "/_api/foxx/service",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getServiceConfiguration",
    value: function getServiceConfiguration(mount) {
      var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var result, values, _i, _Object$keys, key;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._connection.request({
                  path: "/_api/foxx/configuration",
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context11.sent;

                if (!(!minimal || !Object.keys(result).every(function (key) {
                  return result[key].title;
                }))) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return", result);

              case 5:
                values = {};

                for (_i = 0, _Object$keys = Object.keys(result); _i < _Object$keys.length; _i++) {
                  key = _Object$keys[_i];
                  values[key] = result[key].current;
                }

                return _context11.abrupt("return", values);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "updateServiceConfiguration",
    value: function updateServiceConfiguration(mount, cfg) {
      var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var result, result2, _i2, _Object$keys2, key;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._connection.request({
                  method: "PATCH",
                  path: "/_api/foxx/configuration",
                  body: cfg,
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context12.sent;

                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                  return result.values[key].title;
                }))) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt("return", result);

              case 5:
                _context12.next = 7;
                return this.getServiceConfiguration(mount, minimal);

              case 7:
                result2 = _context12.sent;

                if (result.warnings) {
                  for (_i2 = 0, _Object$keys2 = Object.keys(result2); _i2 < _Object$keys2.length; _i2++) {
                    key = _Object$keys2[_i2];
                    result2[key].warning = result.warnings[key];
                  }
                }

                return _context12.abrupt("return", result2);

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "replaceServiceConfiguration",
    value: function replaceServiceConfiguration(mount, cfg) {
      var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var result, result2, _i3, _Object$keys3, key;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._connection.request({
                  method: "PUT",
                  path: "/_api/foxx/configuration",
                  body: cfg,
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context13.sent;

                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                  return result.values[key].title;
                }))) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", result);

              case 5:
                _context13.next = 7;
                return this.getServiceConfiguration(mount, minimal);

              case 7:
                result2 = _context13.sent;

                if (result.warnings) {
                  for (_i3 = 0, _Object$keys3 = Object.keys(result2); _i3 < _Object$keys3.length; _i3++) {
                    key = _Object$keys3[_i3];
                    result2[key].warning = result.warnings[key];
                  }
                }

                return _context13.abrupt("return", result2);

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getServiceDependencies",
    value: function getServiceDependencies(mount) {
      var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var result, values, _i4, _Object$keys4, key;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this._connection.request({
                  path: "/_api/foxx/dependencies",
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context14.sent;

                if (!(!minimal || !Object.keys(result).every(function (key) {
                  return result[key].title;
                }))) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", result);

              case 5:
                values = {};

                for (_i4 = 0, _Object$keys4 = Object.keys(result); _i4 < _Object$keys4.length; _i4++) {
                  key = _Object$keys4[_i4];
                  values[key] = result[key].current;
                }

                return _context14.abrupt("return", values);

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "updateServiceDependencies",
    value: function updateServiceDependencies(mount, cfg) {
      var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var result, result2, _i5, _Object$keys5, key;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._connection.request({
                  method: "PATCH",
                  path: "/_api/foxx/dependencies",
                  body: cfg,
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context15.sent;

                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                  return result.values[key].title;
                }))) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return", result);

              case 5:
                _context15.next = 7;
                return this.getServiceDependencies(mount, minimal);

              case 7:
                result2 = _context15.sent;

                if (result.warnings) {
                  for (_i5 = 0, _Object$keys5 = Object.keys(result2); _i5 < _Object$keys5.length; _i5++) {
                    key = _Object$keys5[_i5];
                    result2[key].warning = result.warnings[key];
                  }
                }

                return _context15.abrupt("return", result2);

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "replaceServiceDependencies",
    value: function replaceServiceDependencies(mount, cfg) {
      var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var result, result2, _i6, _Object$keys6, key;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this._connection.request({
                  method: "PUT",
                  path: "/_api/foxx/dependencies",
                  body: cfg,
                  qs: {
                    mount: mount,
                    minimal: minimal
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context16.sent;

                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                  return result.values[key].title;
                }))) {
                  _context16.next = 5;
                  break;
                }

                return _context16.abrupt("return", result);

              case 5:
                _context16.next = 7;
                return this.getServiceDependencies(mount, minimal);

              case 7:
                result2 = _context16.sent;

                if (result.warnings) {
                  for (_i6 = 0, _Object$keys6 = Object.keys(result2); _i6 < _Object$keys6.length; _i6++) {
                    key = _Object$keys6[_i6];
                    result2[key].warning = result.warnings[key];
                  }
                }

                return _context16.abrupt("return", result2);

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "enableServiceDevelopmentMode",
    value: function enableServiceDevelopmentMode(mount) {
      return this._connection.request({
        method: "POST",
        path: "/_api/foxx/development",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "disableServiceDevelopmentMode",
    value: function disableServiceDevelopmentMode(mount) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/foxx/development",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "listServiceScripts",
    value: function listServiceScripts(mount) {
      return this._connection.request({
        path: "/_api/foxx/scripts",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "runServiceScript",
    value: function runServiceScript(mount, name, args) {
      return this._connection.request({
        method: "POST",
        path: "/_api/foxx/scripts/".concat(name),
        body: args,
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "runServiceTests",
    value: function runServiceTests(mount, opts) {
      return this._connection.request({
        method: "POST",
        path: "/_api/foxx/tests",
        qs: Object.assign({}, opts, {
          mount: mount
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getServiceReadme",
    value: function getServiceReadme(mount) {
      return this._connection.request({
        path: "/_api/foxx/readme",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getServiceDocumentation",
    value: function getServiceDocumentation(mount) {
      return this._connection.request({
        path: "/_api/foxx/swagger",
        qs: {
          mount: mount
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "downloadService",
    value: function downloadService(mount) {
      return this._connection.request({
        method: "POST",
        path: "/_api/foxx/download",
        qs: {
          mount: mount
        },
        expectBinary: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "commitLocalServiceState",
    value: function commitLocalServiceState() {
      var replace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "POST",
        path: "/_api/foxx/commit",
        qs: {
          replace: replace
        }
      }, function () {
        return undefined;
      });
    }
  }, {
    key: "name",
    get: function get() {
      return this._connection.getDatabaseName() || null;
    }
  }]);

  return Database;
}();

exports.Database = Database;

function coerceTransactionCollections(collections) {
  if (typeof collections === "string") {
    return {
      write: [collections]
    };
  }

  if (Array.isArray(collections)) {
    return {
      write: collections.map(colToString)
    };
  }

  if (collection_1.isArangoCollection(collections)) {
    return {
      write: colToString(collections)
    };
  }

  var cols = {};

  if (collections) {
    if (collections.read) {
      cols.read = Array.isArray(collections.read) ? collections.read.map(colToString) : colToString(collections.read);
    }

    if (collections.write) {
      cols.write = Array.isArray(collections.write) ? collections.write.map(colToString) : colToString(collections.write);
    }

    if (collections.exclusive) {
      cols.exclusive = Array.isArray(collections.exclusive) ? collections.exclusive.map(colToString) : colToString(collections.exclusive);
    }
  }

  return cols;
}